import React, { useState } from "react";
import FrontendLayout from "../FrontendLayout";
import Alert from "../../utils/Alert";
import { Link, useNavigate } from "react-router-dom";
import { LOGIN } from "../../data/url";
import httpClient from "../../http/HttpRequest";
import { useCustomerContext } from "../../context/CustomerContext";
import CaptchaLogin from "../front-components/CaptchaLogin";

export default function Login() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ mobile: "", password: "" });
  const [captchaVerified, setCaptachaVerified] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const { updateCustomerData } = useCustomerContext();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
    } else if (captchaVerified) {
      const res = await httpClient.plainRequest(LOGIN, formData);
      if (res.requestStatus === "OK") {
        const result = res.result;
        if (result.status === 1) {
          Alert.success(result.message);
          localStorage.setItem("token", result.data.token);
          updateCustomerData();
          navigate("/");
        } else {
          Alert.error(result.message);
        }
      }
    } else {
      Alert.error("Verify Captcha");
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.mobile.trim()) {
      newErrors.mobile = "Mobile number is required.";
    } else if (!/^\d{10}$/.test(formData.mobile)) {
      newErrors.mobile = "Please enter a valid 10-digit mobile number.";
    }

    if (!formData.password.trim()) {
      newErrors.password = "Password is required.";
    }
    return newErrors;
  };

  const captchaResponse = (res) => {
    setCaptachaVerified(res.captchaVerify === "OK");
  };

  return (
    <FrontendLayout>
      <main className="auth-page">
        <div className="container auth-container">
          <div className="auth-shell wow fadeInUp" data-wow-delay="0.1s">
            <aside className="auth-visual">
              <img src="/assets/img/feature.jpg" alt="Nexways transport service" />
              <div className="auth-visual-overlay"></div>
              <div className="auth-visual-content">
                <span className="auth-visual-badge">
                  <i className="fa fa-truck"></i> Reliable transport network
                </span>
                <h2>Your shipment journey starts here.</h2>
                <p>
                  Sign in to request quotes, confirm bookings and track every
                  transport order from one secure account.
                </p>
                <div className="auth-benefits">
                  <span><i className="fa fa-check"></i> Instant distance quotes</span>
                  <span><i className="fa fa-check"></i> Secure booking history</span>
                  <span><i className="fa fa-check"></i> Dedicated customer support</span>
                </div>
              </div>
              <div className="auth-visual-footer">
                <i className="fa fa-shield-alt"></i>
                <span>Your account details are securely protected</span>
              </div>
            </aside>

            <section className="auth-form-panel">
              <div className="auth-form-wrap">
                <div className="auth-heading">
                  <span className="auth-eyebrow">Customer portal</span>
                  <h1>Welcome back</h1>
                  <p>Enter your registered details to continue to Nexways.</p>
                </div>

                <form className="auth-form" onSubmit={handleSubmit} noValidate>
                  <div className="auth-field">
                    <label htmlFor="loginMobile">Mobile number</label>
                    <div className={`auth-input ${errors.mobile ? "has-error" : ""}`}>
                      <span><i className="fa fa-phone-alt"></i></span>
                      <input
                        type="text"
                        id="loginMobile"
                        name="mobile"
                        value={formData.mobile}
                        onChange={handleChange}
                        placeholder="Enter 10-digit mobile number"
                        inputMode="numeric"
                        maxLength="10"
                        autoComplete="tel"
                        aria-invalid={Boolean(errors.mobile)}
                      />
                    </div>
                    {errors.mobile && <small className="auth-error">{errors.mobile}</small>}
                  </div>

                  <div className="auth-field">
                    <div className="auth-label-row">
                      <label htmlFor="loginPassword">Password</label>
                      <Link to={"/forgetPassword"}>Forgot Password?</Link>
                    </div>
                    <div className={`auth-input ${errors.password ? "has-error" : ""}`}>
                      <span><i className="fa fa-lock"></i></span>
                      <input
                        type={showPassword ? "text" : "password"}
                        id="loginPassword"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        placeholder="Enter your password"
                        autoComplete="current-password"
                        aria-invalid={Boolean(errors.password)}
                      />
                      <button
                        type="button"
                        className="auth-password-toggle"
                        onClick={() => setShowPassword((visible) => !visible)}
                        aria-label={showPassword ? "Hide password" : "Show password"}
                      >
                        <i className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
                      </button>
                    </div>
                    {errors.password && <small className="auth-error">{errors.password}</small>}
                  </div>

                  <div className="auth-captcha-block">
                    <div className="auth-captcha-heading">
                      <span><i className="fa fa-user-shield"></i> Security verification</span>
                      <small>Enter the 5-character code</small>
                    </div>
                    <CaptchaLogin remitCaptcha={captchaResponse} />
                  </div>

                  <button className="auth-submit-button" type="submit">
                    Login securely <i className="fa fa-arrow-right"></i>
                  </button>
                </form>

                <div className="auth-switch">
                  <span>New to Nexways?</span>
                  <Link to={"/register"}>Create an account</Link>
                </div>

                <p className="auth-privacy-note">
                  <i className="fa fa-lock"></i> By continuing, you agree to our secure account policies.
                </p>
              </div>
            </section>
          </div>
        </div>
      </main>
    </FrontendLayout>
  );
}
